import { IProfessional } from "../../types";

interface ProfessionalDetailsProps {
  professional: IProfessional;
}

const AboutDetails = ({ professional }: ProfessionalDetailsProps) => {
  return (
    <div className="border shadow-sm p-6 rounded-lg h-full">
      <p className="text-xl mb-2">About</p>
      <p className="bg-indigo-100/20 border p-2 rounded-lg scrollbar-hide border-indigo-200 max-h-40 overflow-y-auto">
        {professional?.about || <span>Not provided</span>}
      </p>
    </div>
  );
};

export default AboutDetails;
